export const STORAGE_KEYS = {
  PENDING_SUBSCRIPTION: "pendingSubscription",
  // Tracks an in-flight freestyle chat per user — the dialog the client just
  // wrote to dialog-meta and is waiting on the backend (~10s LLM+TTS) to
  // populate dialogs/. Used so a refresh/remount during that window returns
  // into the same chat instead of starting a duplicate.
  FREE_CHAT_INFLIGHT: "freeChatInflight",
  // The same idea for lessons, but a MAP rather than a single slot: the value
  // is an object keyed by `{uid}:{lang}:{courseId}:{unit}-{week}-{lesson}`,
  // each entry holding `{dialogId, createdAt}`. A learner who starts a lesson
  // in a second tab for another language while the first is still generating
  // would otherwise overwrite the first record, and returning to that tab
  // would duplicate the first lesson. Entries older than LessonsView's
  // five-minute TTL are pruned on every read.
  LESSON_INFLIGHT: "lessonInflight",
  // The first tagged touch (utm_source and friends) that brought this browser
  // or device here, as `{source, medium?, campaign?, landedAt?, storedAt}`.
  // Written by src/scripts/acquisition.js at boot, only when no record stored
  // within the last 90 days exists, and read synchronously by the first-sign-in
  // seed in authUtils.js, which copies it into users/{uid}/acquisition. Never
  // cleared after the seed: an existing account ignores it (the seed aborts on
  // an existing node), and a second account created in the same browser inside
  // the window honestly shares the same first touch. It stops being used 90
  // days after storedAt and is replaced by the next tagged visit after that.
  ACQUISITION: "acquisitionFirstTouch",
  // Android only: whether this install still needs to ask the Play Store for
  // its install referrer. The value is either "done" or the number of
  // retryable attempts made so far, as a string ("1" to "4"). Written by the
  // install-referrer bridge in src/scripts/acquisition.js. When Play answers
  // with a referrer, "done" is written only after rememberFirstTouch has
  // returned and the record is confirmed stored, so a process killed between
  // the two can never leave "done" set with nothing stored. It becomes "done"
  // after a terminal answer from Play, or after the fifth retryable failure.
  // A timeout is counted the moment it happens, so on the fifth attempt a
  // referrer Play delivers late is stored after "done" is already set, and is
  // lost if the process dies in between; that keeps the cap absolute. Never cleared: it lives exactly as long as the
  // install's own storage, which is the lifetime Google means when it asks
  // apps to read the referrer once per install. When localStorage is
  // unavailable nothing is written and the read is simply attempted again on
  // every launch.
  INSTALL_REFERRER_STATE: "installReferrerState",
  // A first-sign-in profile write (the seed, seedUserProfileIfMissing in
  // src/scripts/authUtils.js) that was issued and has not settled yet, as
  // `{uid, at}`. The seed writes it just before it issues its transaction and
  // removes it when the transaction commits, aborts because the node exists,
  // or is refused. sign-out removes it too. If a reload or a closed tab cuts
  // the transaction off, the next page load finds it and issues the seed again
  // for that uid, but only when the same account is signed in and the marker
  // is less than 24 hours old; any other marker is removed without seeding.
  PENDING_PROFILE_SEED: "pendingProfileSeed",
};
